import { useEffect, useRef, useState } from "react";
import ApiARIAAuth from "../modules/api/aria-auth";
import AppUser from "../modules/app-user/app-user";

// Refresh ARIA token every 30 minutes (same as main token)
const INTERVAL_REFRESH_ARIA_TOKEN_MS = 30 * 60 * 1000;
const INTERVAL_CHECK_USER_MS = 1000;

export default function useRefreshAriaToken(): { isValid: boolean | undefined; isNetworkError: boolean; initialized: boolean } {
  const [isValid, setIsValid] = useState<boolean>(undefined);
  const [isNetworkError, setIsNetworkError] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const userRef = useRef<{[key: string]: any}>({
    checked: false
  });

  useEffect(() => {
    let timers: NodeJS.Timeout;
    let refresh = async () => {
      const user = await AppUser.getInfo();
      const retry = () => {
        timers = setTimeout(() => refresh(), INTERVAL_REFRESH_ARIA_TOKEN_MS);
      };

      if (user.logged) {
        userRef.current.checked = true;
        const res = await ApiARIAAuth.getToken();

        if (res.status) {
          await AppUser.setInfo({
            aria_token: res.data.accessToken ?? ""
          });
          setIsValid(true);
          retry();
        } else {
          setIsValid(false);
          retry();
        }

        if (res.status === false && res.networkError) {
          setIsNetworkError(true);
          retry();
        } else {
          setIsNetworkError(false);
        }
      } else {
        setIsValid(false);
      }

      return;
    };

    let timersUser: NodeJS.Timeout;
    let userChecker = async () => {
      const user = await AppUser.getInfo();

      if (!user.logged) {
        userRef.current.checked = false;
        setIsValid(false);
      }

      if (user.logged && !userRef.current.checked) {
        userRef.current.checked = true;
        clearTimeout(timers);
        refresh();
      }

      timersUser = setTimeout(() => userChecker(), INTERVAL_CHECK_USER_MS);
    };

    refresh().then(() => {
      setInitialized(true);
      userChecker();
    });

    return () => {
      clearTimeout(timersUser);
      clearTimeout(timers);
    };
  }, []);

  return { isValid, isNetworkError, initialized };
}
